import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { DocStereoTypeDto } from 'projects/shared/src/lib/models/DocStereoTypeDto';
import { DocumentDto, DocumentsDto } from 'projects/shared/src/lib/models/DocumentDto';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { ProjectSessionRequest } from 'projects/shared/src/lib/models/SquirrelSession';
import { ValueConfAttributesDto } from 'projects/shared/src/lib/models/ValueConfAttribute';
import { DataSharingService } from 'projects/shared/src/lib/services/data-sharing.service';
import { DocumentService } from 'projects/shared/src/lib/services/document.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { debounceTime, finalize, switchMap, tap } from 'rxjs/operators';
import { AddDocumentDialogComponent } from './add-document-dialog/add-document-dialog.component';
import { agGridDocumentsSettings } from './ag-document-settings';
import { DocumentButtonRendererComponent } from './document-button-renderer/document-button-renderer.component';
import { UpdateDocumentDialogComponent } from './update-document-dialog/update-document-dialog.component';

import * as documentActions from 'projects/shared/src/lib/ngrx-store/document/document-actions';
import * as attributeValueActions from 'projects/shared/src/lib/ngrx-store/attribute-value/attribute-value-actions';
import * as valueConfPageActions from 'projects/shared/src/lib/ngrx-store/value-conf-page/value-conf-page.actions';
import { ValueConfPageDto, ValueConfPagesDto } from 'projects/shared/src/lib/models/ValueConfPage';

import { getValueConfPages } from 'projects/shared/src/lib/ngrx-store/value-conf-page/value-conf-page.selector';
import { getAttributeValue } from 'projects/shared/src/lib/ngrx-store/attribute-value/attribute-value.selector';
import { getDocument } from 'projects/shared/src/lib/ngrx-store/document/document.selector';
import { EditDocumentComponent } from './edit-document/edit-document.component';
import { Observable, Subject } from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { AttributeValueService } from 'projects/shared/src/lib/services/attribute-value.service';
import { ValueConfPageService } from 'projects/shared/src/lib/services/value-conf-page.service';
@Component({
  selector: 'document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit , OnDestroy, AfterViewInit{

  @ViewChild(EditDocumentComponent)
  private editDocumentComponent!: EditDocumentComponent;

  cntData: any;
  documentDto:any;
  documentStatus:any;
  documentName:any;
  controlData:any;
  valueConfPageDtos:ValueConfPageDto[] = [];
  enableChild = false;

  currentPage:number = 1;
  pageSize:number = 100;
 
  selectedRows!: number;

  docStereoTypeId!: string;
  dbName!: string;

  rowData: DocumentDto[] = [];
  datasource!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;

  //destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private route: ActivatedRoute,
    private render:Renderer2,
    public translate: TranslateService,
    public dialog: MatDialog,
    private documentService: DocumentService,
    private dataSharingService : DataSharingService,
    private attributeValueService: AttributeValueService,
    private valueConfPageService: ValueConfPageService,
    //private readonly store: Store
    // <{
    //   docstereotypes: DocStereoTypeDto[],
    //   projectsessionreq: ProjectSessionRequest,
    //   document: DocumentDto,
    //   currentattributevalue: { controlData: string; selectControl: string; },
    //   valueconfpages: ValueConfPagesDto
    // }>
  ) {

    // this.store.select(getDocument)
    // .pipe(takeUntil(this.destroy$))
    // .subscribe({
    //   next:(document:any) => {
    //     let doc = document.document;
    //     this.documentDto = doc;
    //     this.documentName = doc.name;
    //     this.dataSharingService.passDocumentState(doc);
    //   }
    // })

    // this.store.select(getAttributeValue)
    // .pipe(takeUntil(this.destroy$))
    // .subscribe({
    //   next: (currentattributevalue: any) => {
    //     console.log('----------------currentattributevalue-----------------------')
    //     console.log(currentattributevalue.currentattributevalue)
    //     console.log('---------------------------------------')

    //     this.controlData = currentattributevalue.currentattributevalue.controlData;

    //     this.cntData = JSON.parse(currentattributevalue.currentattributevalue.controlData);
    //     console.log('----------------cntData-----------------------')
    //     console.log(this.cntData)
    //     console.log('---------------------------------------')

    //     this.documentStatus = currentattributevalue.currentattributevalue.selectControl;

    //   }
    // });

    // this.store.select(getValueConfPages)
    // .pipe(takeUntil(this.destroy$))
    // .subscribe({
    //   next: (valueconfpages: any) => {
    //     this.valueConfPageDtos = valueconfpages.valueconfpages.valueConfPageDtos;
    //     console.log('---------------valueConfPageDtos------------------------')
    //     console.log(this.valueConfPageDtos)
    //     console.log('---------------------------------------')
    //   }
    // });


   
  } 
 

  ngOnInit(): void {

    this.route.params.subscribe(params => {
      this.docStereoTypeId = params['id'];
    });

    this.dbName = localStorage.getItem('dbname') as string;

    this.filter = new GenericFilter();
    this.frameworkComponents = {
      buttonRenderer: DocumentButtonRendererComponent
    };
    this.gridOptions = agGridDocumentsSettings;
    this.datasource = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {

        this.filter.className = 'Document';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.documentService.loadAllDocuments(this.docStereoTypeId, this.filter, this.dbName).subscribe({
          next: (data) => {
            this.rowData = data.slice(this.filter.startRow, this.filter.endRow);
            let lastRow = -1;

            if (this.rowData.length <= this.filter.endRow) {
              lastRow = this.rowData.length;
            }
            params.successCallback(this.rowData, lastRow);
          },
          //error
        })

      }
    }  
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDatasource(this.datasource)
  }

  ngAfterViewInit(): void {

  }

  onRowClicked($event: any) {
    // this.store.dispatch(documentActions.invokeDocumentApi({ id: $event.node.data.id, dbname: this.dbName }));
    // this.store.dispatch(attributeValueActions.invokeDocumentAttributeValueApi({ searchtext: '', documentId: $event.node.data.id, currentpage: 1, pagesize: 10, dbname: this.dbName }));
    // this.store.dispatch(valueConfPageActions.invokeValueConfPagesApi({ searchtext: '', docStereoTypeId: this.docStereoTypeId, currentpage: 1, pagesize: 10, dbname: this.dbName }));  
    
    this.documentService.getDocument($event.node.data.id, this.dbName).subscribe({
      next: (documentDto: DocumentDto) => {
        this.documentDto = documentDto;
        this.documentName = this.documentDto.name;

        this.dataSharingService.changesDocumentState(documentDto);

        this.attributeValueService.loadDocumentAttributeValues('',documentDto.id,this.currentPage, this.pageSize, this.dbName).subscribe({
          next : (currentAttributeValueDto: { controlData: string; selectControl: string; }) => {

            this.controlData = currentAttributeValueDto.controlData;

            this.cntData = JSON.parse(currentAttributeValueDto.controlData);
            console.log(this.cntData)

            this.documentStatus = currentAttributeValueDto.selectControl;
            
            if(this.documentStatus === 'Closed') {
              this.render.addClass(document.getElementById('document-status'), 'color-purple')
            }
            else if(this.documentStatus === 'Open') {
              this.render.addClass(document.getElementById('document-status'), 'color-violet')
            }
            else if(this.documentStatus === 'InProgress') {
              this.render.addClass(document.getElementById('document-status'), 'color-blue')
            }
           },
          // error
         });

       // ===== lets retrieve DocumentData tobe displayed ========

        this.valueConfPageService.loadValueConfPages('', this.docStereoTypeId, this.currentPage, this.pageSize, this.dbName).subscribe({
          next: (valueConfPagesDto: ValueConfPagesDto) => {
            this.valueConfPageDtos = valueConfPagesDto.valueConfPageDtos;
          },
          // error
        });
      },
      // error
    });
  }

  onRowSelected($event: any) {
    if ($event.node.selected) {
      this.selectedRows += 1;
    } else {
      this.selectedRows -= 1;
    }
    // taking out, as when we 'select all', it prints to much to the console!!
    //  console.log('onRowSelected: ' + $event.node.data.name);
  }

  openDocumentAddDialog(id: string) {
    const dialogRef = this.dialog.open(AddDocumentDialogComponent, { width: '500px', data: { docStereoTypeId: id } });
    dialogRef.afterClosed().subscribe({
      next: result => {

        if (result !== undefined) {
          this.documentService.createDocument(result, this.dbName).subscribe({
            next: (document) => {
              this.rowData.splice(2,0,document);
              this.rowData.push(document);
              this.gridApi.refreshInfiniteCache();
            },
            //error
          })
        }
      },
      //error
    });
  }

  ngOnDestroy(): void {
    // this.destroy$.next(true);
    // this.destroy$.unsubscribe();
  }
}
